var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"preloader",class:[`_${_vm.position}`]},[_c('div',{staticClass:"preloader__icon"},[_c('div',{staticClass:"preloader__icon-svg"},[_c('svg-inline',[_c('icon',{attrs:{"icon":"loader-circle"}})],1)],1)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }